export default __webpack_public_path__ + "static/media/login.4c89f98f.png";